/**
 * convert to absolute site core path
 * @param relativePath
 * @returns
 */
export function toSiteCorePath(
    relativePath: string | string[] | undefined,
    rootPath = process.env.SITECORE_ROOT_PATH
): string {
    if (relativePath instanceof Array) {
        relativePath = relativePath.join('/');
    } else if (!relativePath) {
        relativePath = '';
    }
    const path = `${rootPath}/${relativePath}`;
    return path;
}

export function withBasePath(subpath: string): string {
    const APP_BASE_PATH = process.env.NEXT_PUBLIC_APP_BASE_PATH;
    if (APP_BASE_PATH) {
        const path = `/${APP_BASE_PATH}${subpath}`;
        return path;
    } else {
        return subpath;
    }
}

export function withFullPath(path?: string): string {
    if (!path) {
        return path || '';
    }
    if (path.startsWith('http:') || path.startsWith('https:')) {
        return path;
    }
    const MEDIA_FULL_PATH = /(?=.*\/\/)(?=.*-\/media\/).*$/;
    if (MEDIA_FULL_PATH.test(path)) {
        return `https:${path}`;
    }
    return path;
}
